import SimpleBarChart from '@shared/components/chart/simple-bar-chart';
import { ChartConfig } from '@shared/components/ui/chart';

interface PreviewSheetBarChartProps {
  nameKey: string;
  chartData: any;
  chartConfig: ChartConfig;
}

export const PreviewSheetBarChart = ({
  chartData,
  chartConfig,
  nameKey,
}: PreviewSheetBarChartProps) => {
  const limitedChartData = chartData?.slice(0, 10); // Limit to first 10

  return (
    <SimpleBarChart
      nameKey={nameKey}
      dataKey="emissions"
      chartData={limitedChartData}
      chartConfig={chartConfig}
      className="size-full"
      layout="vertical"
      // The grid's horizontal lines run behind the bars as tracks and draw a
      // rule along the top; a bar list reads better without them.
      CartesianGridProps={{ horizontal: false }}
      barCategoryGap={'20%'}
      margin={{ left: 20, top: 10 }}
      MaxBarSize={50}
      barSize={50}
      YAxisProps={{
        tickLine: false,
        axisLine: false,
        // Room for a two-word label on one line; the default 60px wraps
        // most names onto three.
        width: 130,
        // Every row keeps its label, however many bars there are.
        interval: 0,
      }}
      XAxisProps={{
        label: {
          value: 'tCO2e',
          position: 'right',
          offset: 20,
        },
        hide: true,
      }}
    />
  );
};
